import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableItemsPerPageSelect = _resolveComponent("TableItemsPerPageSelect")!
  const _component_TablePagination = _resolveComponent("TablePagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TableItemsPerPageSelect, {
      itemsPerPage: _ctx.itemsCountInTable,
      "onUpdate:itemsPerPage": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.itemsCountInTable) = $event)),
      "items-per-page-dropdown-enabled": _ctx.itemsPerPageDropdownEnabled
    }, null, 8, ["itemsPerPage", "items-per-page-dropdown-enabled"]),
    (_ctx.pageCount > 1)
      ? (_openBlock(), _createBlock(_component_TablePagination, {
          key: 0,
          "total-pages": _ctx.pageCount,
          total: _ctx.count,
          "per-page": _ctx.itemsPerPage,
          "current-page": _ctx.page,
          onPageChange: _ctx.pageChange
        }, null, 8, ["total-pages", "total", "per-page", "current-page", "onPageChange"]))
      : _createCommentVNode("", true)
  ]))
}